export default __webpack_public_path__ + "media/images/shapes/slice-b065f19e34a407c22d88c369d340f132.svg";